import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/reseller-products`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/reseller-products/${id}?include=reseller`, options)
    .then((response) => {
      let resellerProduct = jsona.deserialize(response.data);
      delete resellerProduct.links;
      return resellerProduct;
    });
}

function add(resellerProduct) {
  const payload = jsona.serialize({
    stuff: resellerProduct,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/reseller-products`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(resellerProduct) {
  const payload = jsona.serialize({
    stuff: resellerProduct,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/reseller-products/${resellerProduct.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/reseller-products/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
